export const locale = {
    lang: "es",
    data: {
        NAV: {
            QUOTES: "Cotizaciones",
            QUOTE: {
                TITLE: "Cotizar",
                //'BADGE': '25'
            },
            MYQUOTES: {
                TITLE: "Cotizaciones",
                //'BADGE': '2'
            },
            DASHBOARDS: "Inicio",
            DASHBOARD: {
                TITLE: "Inicio",
                //'BADGE': '25'
            },
            ORDERS: "Órdenes de trabajo",
            ORDER: {
                TITLE: "Órdenes de trabajo",
                //'BADGE': '25'
            },
            BILLS: "Facturas",
            BILL: {
                TITLE: "Facturas",
                //'BADGE': '25'
            },
            PURCHASEORDERS: "Órdenes de compra",
            PURCHASE: {
                TITLE: "Órdenes de compra",
                //'BADGE': '25'
            },
            MAINTAINERS: "Mantenedores",
            CLIENT: {
                TITLE: "Clientes",
                //'BADGE': '25'
            },
            CONTRACTORS: {
                TITLE: "Contratistas",
                //'BADGE': '25'
            },
            USERS: {
                TITLE: "Usuarios",
                //'BADGE': '25'
            },
            CATALOGUE: {
                TITLE: "Catálogo de servicios",
                //'BADGE': '25'
            },
            TAX: {
                TITLE: "Recargo comunas",
                //'BADGE': '25'
            },
            MANAGER: {
                TITLE: "Supervisores",
                //'BADGE': '25'
            },            
            

        },
    },
};
